export const applicationDetailsFieldNames = {
  applicationId: "applicationId",
  memberId: "memberId", //currently disabled for rejected,canceled, ineligible,notInterested,notReturned
  assistanceType: "assistanceType",
  brandName: "approvedRxnormDrugs",
  relevantDrugs: "approvedRxnormDrugs",
  diagnosisCovered: "diagnosisDiscovered",
  drugType: "isFreeDrugOrder",
  manageTailormedPharmacy: "createPharmacyPatient",
  appliedDate: "appliedDate",
  lookbackRelevanceDate: "lookbackRelevanceDate",
  approvedDate: "approvedDate",
  validThrough: "validThrough",
  approvedAmount: "approvedAmount",
  effectiveIndefinitely: "effectiveIndefinitely",
  canceledDate: "canceledDate",
  rejectedDate: "rejectedDate",
  rejectReason: "rejectReason",
  assignee: "assignee",
  tags: "tags"
};
export const billingInformationFieldNames = {
  bin: "bin",
  pcn: "pcn",
  group: "group",
  billingInformationAvailable: "billingInformationAvailable",
  copayCard: "copayCard",
  cvv: "cvv",
  zip: "zip",
  expiryDate: "expiryDate"
};
export const preparationDetailsFieldNames = {
  sentToPatientOn: "sentToPatientOn",
  receivedFromPatientOn: "receivedFromPatientOn",
  sentToPhysicianOn: "sentToPhysicianOn",
  receivedFromPhysicianOn: "receivedFromPhysicianOn",
  mailTrackingOutbound: "mailTrackingOutbound",
  mailTrackingInbound: "mailTrackingInbound",
  personNameYouSpokeTo: "personNameYouSpokeTo"
};

export const BILLING_INFORMATION_SECTION_ID = "track_panel_billing_information";
export const PREPARATION_DETAILS_SECTION_ID = "track_panel_preparation_details";
export const PREVIOUS_ENROLLMENT_SECTION_ID = "previous_enrollment_section";
export const ENROLLMENT_DETAILS_SECTION_ID = "track_panel_enrollment_details";
